import * as React from 'react';

export interface AmenityBodyProps {
  text: string;
  index: number;
  category: string;
}

export const AmenityBody: React.FunctionComponent<AmenityBodyProps> = ({ text, index, category }) => (
  <div
    className={`policies__body uitk-type-list-300 info-${category}__section__body`}
    dangerouslySetInnerHTML={{ __html: text }}
    key={`${category}-${index}`}
  />
);
